import React from "react";
import { TextField } from "@mui/material";

interface Props {
  tip: number;
  customTip: string;
  isCompleted: boolean;
  onTipChange: (amount: number) => void;
  onCustomTipChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  themeBorderColor: string;
  themeTextColor: string;
  themeRingColor: string;
  getLightBgClass: () => string;
}

const TipSelector: React.FC<Props> = ({ tip, customTip, isCompleted, onTipChange, onCustomTipChange, themeBorderColor, themeTextColor, themeRingColor, getLightBgClass }) => {
  const tipOptions = [
    { amount: 0, label: "No Tip", emoji: "🙅" },
    { amount: 5, label: "5", emoji: "👍" },
    { amount: 10, label: "10", emoji: "💫" },
    { amount: 15, label: "15", emoji: "🌟" },
  ];

  return (
    <div className="mb-2">
      <h3 className="font-semibold text-gray-800 text-base mb-1.5 mt-0.5 leading-none">Add Tips</h3>

      <div className="grid grid-cols-2 gap-2.5 mb-2">
        {tipOptions.map(({ amount, label, emoji }) => (
          <button
            key={amount}
            onClick={() => onTipChange(amount)}
            disabled={isCompleted}
            className={`p-1.5 rounded-lg border text-sm transition-all duration-150 font-medium
              ${tip === amount ? `${themeBorderColor} ${getLightBgClass()} ${themeTextColor} shadow-sm scale-[1.02] ring-1 ${themeRingColor}` : "border-gray-200 bg-white text-gray-700 hover:border-blue-300 hover:bg-blue-25"}
              ${isCompleted ? "opacity-50 cursor-not-allowed" : ""}`}
          >
            <div className="flex items-center justify-center gap-1 leading-none">
              <span className="text-sm">{emoji}</span>
              <span>{label}</span>
            </div>
          </button>
        ))}
      </div>

      <TextField
        label="Custom Tip Amount"
        variant="outlined"
        type="number"
        size="small"
        fullWidth
        value={customTip}
        onChange={onCustomTipChange}
        disabled={isCompleted}
        sx={{ "& .MuiOutlinedInput-root": { borderRadius: "10px", fontSize: "13px", height: "36px" }, "& .MuiInputLabel-root": { fontSize: "13px", } }}
      />
    </div>
  );
};

export default TipSelector;
